import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import profile from '../assets/default_user.png'
import parse from 'html-react-parser'
import TextTranslator from '../util/TextTranslator'
import MemberBadge from '../models/MemberBadge'
import Badge from '../models/Badge'

export default function ResultCard(props) {
    const { result } = props
    const [badges, setBadges] = useState([])

    useEffect(() => {
        const fetchBadges = async () => {
            try {
                if (!result.id) return

                const memberBadge = new MemberBadge()
                const badge = new Badge()

                const badgesResponse = await memberBadge.getByMemberID(result.id)
                const badgeAssignments = Array.isArray(badgesResponse)
                    ? badgesResponse
                    : badgesResponse?.data || []

                if (badgeAssignments.length > 0) {
                    const badgeDetails = await Promise.all(
                        badgeAssignments.map(async (assignment) => {
                            try {
                                const badgeDetail = await badge.getById(assignment.badge_id)
                                return {
                                    id: badgeDetail.id || assignment.badge_id,
                                    name: badgeDetail.label || `Badge ${assignment.badge_id}`,
                                    image_url: badgeDetail.icon_url,
                                    date_start: assignment.date_start,
                                    date_end: assignment.date_end,
                                }
                            } catch (e) {
                                console.error(`Error loading badge ${assignment.badge_id}:`, e)
                                return null
                            }
                        }),
                    )

                    // Filter out null values and expired badges
                    const currentDate = new Date()
                    const activeBadges = badgeDetails
                        .filter((b) => b !== null)
                        .filter((badge) => {
                            if (!badge.date_end) return true // Keep if no expiration date
                            const endDate = new Date(badge.date_end)
                            return endDate >= currentDate
                        })

                    setBadges(activeBadges)
                } else {
                    setBadges([])
                }
            } catch (error) {
                console.error('Error fetching badges:', error)
                setBadges([])
            }
        }

        fetchBadges()
    }, [result.id])

    const formatResume = (text) => {
        if (text.length > 250) return text.slice(0, 250) + '...'
        return text
    }

    return (
        <Col style={{ cursor: 'pointer', textDecoration: 'none' }}>
            <Link style={{ textDecoration: 'none' }} to={`/result/${result.id}`}>
                <Row
                    style={{
                        fontFamily: 'Open Sans',
                        boxShadow: '1px 1px 6px #00000014',
                        borderRadius: 10,
                        fontSize: '.85em',
                        color: 'black',
                        paddingTop: 15,
                        paddingBottom: 15,
                    }}
                >
                    <Col md={3}>
                        <div
                            style={{
                                textAlign: 'center',
                                paddingBottom: 10,
                            }}
                        >
                            <img
                                src={
                                    result?.profile_picture_url
                                        ? result.profile_picture_url
                                        : profile
                                }
                                style={{
                                    maxWidth: '100%',
                                    objectFit: 'contain',
                                    borderRadius: 5,
                                }}
                                alt={result?.full_name}
                            />
                        </div>
                    </Col>
                    <Col className="mt-3">
                        <div
                            style={{
                                fontFamily: 'Roboto',
                                fontSize: 15,
                            }}
                        >
                            {result?.full_name}
                        </div>

                        <div
                            className="d-flex flex-wrap"
                            style={{ gap: '4px', marginTop: '4px', marginBottom: '4px' }}
                        >
                            {result.profession === 'Both' || result.profession === 'both' ? (
                                <>
                                    <div
                                        className="px-2"
                                        style={{
                                            color: '#224AD7',
                                            borderColor: '#224AD7',
                                            borderRadius: '20px',
                                            border: 'thin solid',
                                            fontSize: '0.8rem',
                                        }}
                                    >
                                        Juru Bahasa
                                    </div>
                                    <div
                                        className="px-2"
                                        style={{
                                            color: '#224AD7',
                                            borderColor: '#224AD7',
                                            borderRadius: '20px',
                                            border: 'thin solid',
                                            fontSize: '0.8rem',
                                        }}
                                    >
                                        Penerjemah
                                    </div>
                                </>
                            ) : (
                                <div
                                    className="px-2"
                                    style={{
                                        color: '#224AD7',
                                        borderColor: '#224AD7',
                                        borderRadius: '20px',
                                        border: 'thin solid',
                                        fontSize: '0.8rem',
                                    }}
                                >
                                    {TextTranslator.getProfesi(result.profession)}
                                </div>
                            )}
                        </div>

                        {badges.length > 0 && (
                            <div
                                className="d-flex flex-wrap"
                                style={{ gap: '4px', marginBottom: '8px' }}
                            >
                                {badges.map((badge) => (
                                    <div
                                        key={`badge-${badge.id}`}
                                        className="px-2"
                                        style={{
                                            //color: '#224AD7',
                                            // borderColor: '#224AD7',
                                            borderRadius: '20px',
                                            // border: 'thin solid',
                                            fontSize: '0.8rem',
                                            display: 'flex',
                                            alignItems: 'center',
                                            backgroundColor: '#D3D3D3',
                                            padding: '2px 8px',
                                        }}
                                    >
                                        {badge.image_url && (
                                            <img
                                                src={badge.image_url}
                                                alt={badge.name}
                                                style={{
                                                    width: '12px',
                                                    height: '12px',
                                                    //marginRight: '4px',
                                                }}
                                            />
                                        )}
                                        {/* <span>{badge.name}</span> */}
                                    </div>
                                ))}
                            </div>
                        )}

                        {result.resume && (
                            <div className="mt-2">{parse(formatResume(result.resume))}</div>
                        )}
                    </Col>
                </Row>
            </Link>
        </Col>
    )
}
